import React, { FC } from 'react'
import styled from 'styled-components'

export const TitleWrapper = styled.div`
  text-align: center;

  h1,
  h2,
  h3,
  h4 {
    color: ${({ theme }) => theme.colors.greyDark};
    word-wrap: break-word;
  }

  h4 {
    letter-spacing: .5px;
    margin: 20px 0 0;
    font-size: 1.25rem;
    line-height: 1.2;
    padding: 0 0 10px;
    text-align: center;
    text-transform: uppercase;
  }

  .subtitle {
    color: ${({ theme }) => theme.colors.grey};
    line-height: 1.4;
  }
`

interface TitleTextProps {
  title: string
  type: 'h1' | 'h2' | 'h3' | 'h4'
}

const TitleText: FC<TitleTextProps> = ({ title, type }) => {
  if (type === 'h1') {
    return (
      <h1>{title}</h1>
    )
  }
  if (type === 'h2') {
    return (
      <h2>{title}</h2>
    )
  }
  if (type === 'h3') {
    return (
      <h3 style={{ maxWidth: '750px', marginLeft: 'auto', marginRight: 'auto' }}>{title}</h3>
    )
  }
  return (
    <h4>{title}</h4>
  )
}

interface TitleProps extends TitleTextProps {
  className?: string
  subtitle?: string
}

export const Title: FC<TitleProps> = ({ className, subtitle, type, ...props }) => (
  <TitleWrapper className={className}>
    <TitleText type={type} {...props} />
    {subtitle && (type === 'h1' || type === 'h2') && (
      <p className="subtitle">{subtitle}</p>
    )}
  </TitleWrapper>
)
